import moment from "moment-timezone";
import { formatDecimal } from "../utils/decimalFormat";
const OrderDetailsPopup = ({ order, popup, setPopup }) => {
  const orderStatus = (status) => {
    let currentOrderStatus = "";
    switch (status) {
      case "scheduled":
        currentOrderStatus = "Scheduled";
        break;
      case "0":
        currentOrderStatus = "Pending";
        break;
      case "-1":
        currentOrderStatus = "Failed";
        break;
      case "1":
        currentOrderStatus = "Pickup";
        break;
      case "2":
        currentOrderStatus = "Arrived";
        break;
      case "3":
      case "4":
        currentOrderStatus = "Scanned";
        break;
      case "5":
        currentOrderStatus = "En Route";
        break;
      case "6":
        currentOrderStatus = "Completed";
        break;
      case "-2":
      case "-3":
        currentOrderStatus = "Cancelled";
        break;

      default:
        currentOrderStatus = "";
        break;
    }
    return currentOrderStatus;
  };
  return (
    <div
      className={
        popup === true
          ? "modal fade effect-slide-in-bottom show bg-success-transparent"
          : "modal fade effect-slide-in-bottom"
      }
      style={popup === true ? { display: "block" } : {}}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content modal-content-demo">
          <div className="modal-header">
            <h6 className="modal-title">DETAILS</h6>
            <button
              onClick={() => {
                setPopup(false);
              }}
              aria-label="Close"
              className="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div className="modal-body p-0">
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <th colSpan={4} className="text-center">
                      BASIC DETAILS
                    </th>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">
                      Order Id
                    </th>
                    <td className="border-end">{order?.orderId}</td>
                    <th className="border-end bg-success-transparent">
                      {order?.scheduledAt === null
                        ? "Order Date & Time"
                        : "Scheduled At"}
                    </th>
                    <td>
                      {order?.scheduledAt === null
                        ? moment(order?.orderDateTime)
                          .tz(process.env.REACT_APP_TIMEZONE)
                          .format("Do MMM, YYYY, hh:mm A")
                        : moment(order?.scheduledAt)
                          .tz(process.env.REACT_APP_TIMEZONE)
                          .format("Do MMM, YYYY, hh:mm A")}
                    </td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">
                      Reference Id
                    </th>
                    <td colSpan={3} style={{ wordBreak: "break-all" }}>
                      {order?.referenceId ? order.referenceId : "---"}
                    </td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">
                      Order Amount
                    </th>
                    <td className="border-end">{order?.orderAmount}</td>
                    <th className="border-end bg-success-transparent">
                      Order Channel
                    </th>
                    <td>{order?.orderChannel}</td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">
                      Status
                    </th>
                    <td className="border-end">{orderStatus(order?.status)}</td>
                    <th className="border-end bg-success-transparent">
                      Distance
                    </th>
                    <td>{order?.distance ?? 0} Km</td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">Time</th>
                    <td className="border-end">{order?.time ?? 0} min</td>
                    <th className="border-end bg-success-transparent">Fee</th>
                    <td>{formatDecimal(order?.feeInt)}</td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">
                      Payment Type
                    </th>
                    <td className="border-end">{order?.paymentType ?? "---"}</td>
                    <th className="border-end bg-success-transparent">
                      Transaction Id
                    </th>
                    <td>{order?.transactionId ?? "---"}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            {order?.items && order?.items?.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th colSpan={4} className="text-center">
                        ORDER ITEMS
                      </th>
                    </tr>
                    <tr>
                      <th className="border-end bg-success-transparent">
                        Product
                      </th>
                      <th className="border-end bg-success-transparent">
                        Quantity
                      </th>
                    </tr>
                    {order?.items?.map((item, index) => {
                      const hasModifiers =
                        Array.isArray(item?.modifiers) &&
                        item?.modifiers?.length > 0;
                      const displayName = hasModifiers
                        ? `${item?.name} (${item?.modifiers?.join(", ")})`
                        : item?.name;
                      return (
                        <tr key={index}>
                          <td className="border-end">{displayName}</td>
                          <td className="border-end">{item?.quantity}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
            <div className="table-responsive">
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <th colSpan={4} className="text-center">
                      CUSTOMER DETAILS
                    </th>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">
                      Customer Name
                    </th>
                    <td className="border-end">{order?.customerName}</td>
                    <th className="border-end bg-success-transparent">
                      Customer Phone
                    </th>
                    <td>{order?.customerPhone}</td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">Area</th>
                    <td className="border-end">{order?.area?.value}</td>
                    <th className="border-end bg-success-transparent">Block</th>
                    <td>{order?.block?.value}</td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">
                      Street
                    </th>
                    <td colSpan={3} className="border-end">
                      {order?.street?.value}
                    </td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">Jadda</th>
                    <td className="border-end">{order?.jadda?.trim() === "" ? "---" : order?.jadda}</td>
                    <th className="border-end bg-success-transparent">
                      Apartment
                    </th>
                    <td>{order?.apartment?.trim() === "" ? "---" : order?.apartment}</td>
                  </tr>
                  <tr>
                    <th className="border-end bg-success-transparent">Floor</th>
                    <td className="border-end">{order?.floor?.trim() === "" ? "---" : order?.floor}</td>
                    <th className="border-end bg-success-transparent">
                      Building
                    </th>
                    <td>{order?.building?.trim() === "" ? "---" : order?.building}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => setPopup(false)}
              className="btn btn-danger"
            >
              CLOSE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsPopup;
